import { useState, useEffect } from 'react';
import { collection, getDocs, query, where } from 'firebase/firestore';
import { db } from '@services/firebase';
import { Users, FileText, ShieldCheck, BookOpen } from 'lucide-react';

function StatCard({ icon: Icon, label, value, color }) {
  return (
    <div className="bg-white rounded-2xl shadow-sm p-6 flex items-center gap-4">
      <div className={`w-12 h-12 rounded-xl flex items-center justify-center ${color}`}>
        <Icon size={22} className="text-white" />
      </div>
      <div>
        <p className="text-sm text-gray-500">{label}</p>
        <p className="text-2xl font-bold text-gray-800">
          {value === null ? '…' : value}
        </p>
      </div>
    </div>
  );
}

export default function AdminDashboard() {
  const [stats, setStats] = useState({ users: null, admins: null, posts: null, published: null });

  useEffect(() => {
    (async () => {
      const [usersSnap, postsSnap] = await Promise.all([
        getDocs(collection(db, 'users')),
        getDocs(collection(db, 'blog_posts')),
      ]);

      const adminCount = usersSnap.docs.filter(d => d.data().role === 'admin').length;
      const publishedCount = postsSnap.docs.filter(d => d.data().published !== false).length;

      setStats({
        users:     usersSnap.size,
        admins:    adminCount,
        posts:     postsSnap.size,
        published: publishedCount,
      });
    })();
  }, []);

  return (
    <div className="p-8">
      <h1 className="text-2xl font-bold text-gray-800 mb-2">Dashboard</h1>
      <p className="text-gray-500 mb-8">Overview of your DataLogicHub site.</p>

      <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-5">
        <StatCard icon={Users}      label="Total users"      value={stats.users}     color="bg-[#1E3A8A]" />
        <StatCard icon={ShieldCheck} label="Admin users"     value={stats.admins}    color="bg-[#7C3AED]" />
        <StatCard icon={FileText}   label="Total posts"      value={stats.posts}     color="bg-[#14B8A6]" />
        <StatCard icon={BookOpen}   label="Published posts"  value={stats.published} color="bg-[#F59E0B]" />
      </div>
    </div>
  );
}
